import { _defaultToString } from './utils';
/* eslint-disable */
let nameCache = Object.create(null);
let cmdCache = Object.create(null);
let refCache = Object.create(null);
export class _PdfName {
    constructor(name) {
        this.name = name;
    }
    static get(name) {
        return nameCache[name] || (nameCache[name] = new _PdfName(name));
    }
}
export class _PdfCommand {
    constructor(command) {
        this.command = command;
    }
    static get(command) {
        return cmdCache[command] || (cmdCache[command] = new _PdfCommand(command));
    }
}
export class _PdfReference {
    constructor(objectNumber, gen) {
        this._isNew = false;
        this.objectNumber = objectNumber;
        this.generationNumber = gen;
    }
    toString() {
        return `${this.objectNumber} ${this.generationNumber}`;
    }
    static get(objectNumber, generationNumber) {
        const key = generationNumber === 0 ? `${objectNumber}R` : `${objectNumber}R${generationNumber}`;
        return refCache[key] || (refCache[key] = new _PdfReference(objectNumber, generationNumber));
    }
}
export class _PdfReferenceSet {
    constructor(parent = null) {
        this._set = new Set(parent && parent._set);
    }
    has(ref) {
        return this._set.has(ref.toString());
    }
    put(ref) {
        this._set.add(ref.toString());
    }
    remove(ref) {
        this._set.delete(ref.toString());
    }
    clear() {
        this._set.clear();
    }
}
export class _PdfReferenceSetCache {
    constructor() {
        this._map = new Map();
    }
    get size() {
        return this._map.size;
    }
    get(ref) {
        return this._map.get(ref.toString());
    }
    has(ref) {
        return this._map.has(ref.toString());
    }
    put(ref, obj) {
        this._map.set(ref.toString(), obj);
    }
    set(objId, obj) {
        this._map.set(objId, obj);
    }
    clear() {
        this._map.clear();
    }
}
export class Dictionary {
    constructor(toStringFunction) {
        this.table = {};
        this.nElements = 0;
        this.toStr = toStringFunction || _defaultToString;
    }
    getValue(key) {
        const pair = this.table['$' + this.toStr(key)];
        if (typeof pair === 'undefined') {
            return undefined;
        }
        return pair.value;
    }
    setValue(key, value) {
        let ret;
        const k = '$' + this.toStr(key);
        const previousElement = this.table[k];
        this.nElements++;
        ret = undefined;
        this.table[k] = {
            key: key,
            value: value
        };
        return ret;
    }
    keys() {
        const keysArray = [];
        let namesOfKeys = Object.keys(this.table);
        for (let index1 = 0; index1 < namesOfKeys.length; index1++) {
            const pair1 = this.table[namesOfKeys[index1]];
            keysArray.push(pair1.key);
        }
        return keysArray;
    }
    containsKey(key) {
        let retutnValue = true;
        if (typeof this.getValue(key) === 'undefined') {
            retutnValue = true;
        }
        else {
            retutnValue = false;
        }
        return !retutnValue;
    }
    _size() {
        return this.nElements;
    }
}
export class _PdfDictionary {
    constructor(xref) {
        this._isFont = false;
        this._isProcessed = false;
        this._initialize(xref);
    }
    get size() {
        return Object.keys(this._map).length;
    }
    assignXref(xref) {
        this._crossReference = xref;
    }
    getRaw(key) {
        return this._map[key];
    }
    getRawValues() {
        return this._map.values;
    }
    get(key1, key2, key3) {
        let value = this._get(key1, key2, key3);
        if (this._crossReference && typeof value !== 'undefined' && value instanceof _PdfReference) {
            value = this._crossReference._fetch(value);
        }
        return value;
    }
    getArray(key1, key2, key3) {
        const rawValue = this.get(key1, key2, key3);
        if (this._crossReference && Array.isArray(rawValue)) {
            return rawValue.map((item) => {
                return item instanceof _PdfReference ? this._crossReference._fetch(item) : item;
            });
        }
        return rawValue;
    }
    set(key, value) {
        this._map[key] = value;
    }
    has(key) {
        return typeof this._map[key] !== 'undefined';
    }
    forEach(callback) {
        for (const key in this._map) {
            callback(key, this.getRaw(key));
        }
    }
    update(key, value) {
        if (this.has(key)) {
            let prevValue = this._map[key];
            if (prevValue !== null && typeof prevValue !== 'undefined' && prevValue instanceof _PdfReference && this._crossReference) {
                prevValue = this._crossReference._fetch(prevValue);
            }
            if (prevValue !== value) {
                this._map[key] = value;
                this._updated = true;
            }
        }
        else {
            this._map[key] = value;
            this._updated = true;
        }
    }
    static getEmpty(xref) {
        const emptyDict = new _PdfDictionary(xref);
        emptyDict.set = (key, value) => {
            throw new Error('Should not call set on the empty dictionary.');
        };
        return emptyDict;
    }
    static merge(xref, dictionaryArray, mergeSubDictionary = false) {
        const mergedDictionary = new _PdfDictionary(xref);
        const properties = Object.create(null);
        for (const dictionary of dictionaryArray) {
            if (!(dictionary instanceof _PdfDictionary)) {
                continue;
            }
            for (const [key, value] of dictionary._map) {
                let property = properties.get(key);
                if (typeof property === 'undefined') {
                    property = [];
                    properties.set(key, property);
                }
                else if (!mergeSubDictionary || !(value instanceof _PdfDictionary)) {
                    continue;
                }
                property.push(value);
            }
        }
        for (const [name, values] of properties) {
            if (values.length === 1 || !(values[0] instanceof _PdfDictionary)) {
                mergedDictionary._map[name] = values[0];
                continue;
            }
            const subDict = new _PdfDictionary(xref);
            for (const dictionary of values) {
                for (const [key, value] of dictionary._map) {
                    if (typeof subDict._map[key] === 'undefined') {
                        subDict._map[key] = value;
                    }
                }
            }
            if (subDict.size > 0) {
                mergedDictionary._map[name] = subDict;
            }
        }
        properties.clear();
        return mergedDictionary.size > 0 ? mergedDictionary : _PdfDictionary.getEmpty(xref);
    }
    _initialize(xref) {
        this._map = Object.create(null);
        this.suppressEncryption = false;
        this._updated = false;
        this.isCatalog = false;
        this._isNew = false;
        if (xref) {
            this._crossReference = xref;
        }
    }
    _get(key1, key2, key3) {
        let value = this._map[key1];
        if (typeof value === 'undefined') {
            value = this._map[key2];
            if (typeof key2 !== 'undefined' && key2 !== null) {
                value = this._map[key2];
            }
            else if (typeof key3 !== 'undefined' && key3 !== null) {
                value = this._map[key3];
            }
        }
        return value;
    }
}
export class _PdfNull {
    constructor(value = []) {
        this.value = value;
    }
}
export function _clearPrimitiveCaches() {
    nameCache = Object.create(null);
    cmdCache = Object.create(null);
    refCache = Object.create(null);
}
export function _isName(value, name) {
    return value instanceof _PdfName && (typeof name === 'undefined' || value.name === name);
}
export function _isCommand(value, command) {
    return value instanceof _PdfCommand && (typeof command === 'undefined' || value.command === command);
}
